import { EstadosLiberacionValorInstalacionEnumChoice, a11yProps, useCheckPermissions } from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { CustomTabPanel } from "../../component";
import TableLiberacionValorInstalacionComponente from "./componente/TableLiberacionValorInstalacionComponente";
import { PermissionsEnum } from "@/auth/interfaces";

export default function LiberacionValorInstalacionPage() {

  useCheckPermissions(PermissionsEnum.api_view_solicitudnocobroinstalacion);

  const [valueTab, setValueTab] = useState(0);

  return <SingleTableBoxScene title="Liberación para Valor de Instalación">
    <Tabs
      value={valueTab}
      onChange={(_event: React.SyntheticEvent, newValue: number) => {
        setValueTab(newValue);
      }}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      aria-label="scrollable force tabs solicitud-liberacion-valor-instalacion"
    >
      <Tab label={'Pendiente'} {...a11yProps(0)} />
      <Tab label={'Aprobado'} {...a11yProps(1)} />
      <Tab label={'Rechazado'} {...a11yProps(2)} />
    </Tabs>
    <CustomTabPanel index={valueTab} value={0}>
      <TableLiberacionValorInstalacionComponente
        accion={true}
        estado_solicitud={EstadosLiberacionValorInstalacionEnumChoice.EN_ESPERA}
      />
    </CustomTabPanel>
    <CustomTabPanel index={valueTab} value={1}>
      <TableLiberacionValorInstalacionComponente
        accion={false}
        estado_solicitud={EstadosLiberacionValorInstalacionEnumChoice.APROBADO}
      />
    </CustomTabPanel>
    <CustomTabPanel index={valueTab} value={2}>
      <TableLiberacionValorInstalacionComponente
        accion={false}
        estado_solicitud={EstadosLiberacionValorInstalacionEnumChoice.RECHAZADO}
      />
    </CustomTabPanel>

  </SingleTableBoxScene>

}